import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Row, Col, Form, Table, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { var_api } from '../../constant';
import Swal from "sweetalert2";

const AppointmentSummary = () => {
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [filterType, setFilterType] = useState(null);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const [clientsData, setClientsData] = useState(null);
  const history = useHistory();

  useEffect(() => {
    fetchClients();
  }, [startDate, endDate]);

  function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  }

  const fetchClients = async () => {
    try {
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${var_api}/api/booking/get-appointment-summary/${formattedStartDate}/${formattedEndDate}`,
        {
          headers: { Authorization: `${token}` }
        }
      );
      setClientsData(response.data);
      setPopupLast30Days(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const downloadCombinedExcel = () => {
    const summaryData = [
      { "Metric": "Total Bookings Count", "Value": clientsData ? clientsData.total_bookings_count : "-" },
      { "Metric": "Coupon Orders Count", "Value": clientsData ? clientsData.coupon_orders_count : "-" },
      { "Metric": "Membership Orders Count", "Value": clientsData ? clientsData.membership_orders_count : "-" },
      { "Metric": "Instant Orders Count", "Value": clientsData ? clientsData.instant_orders_count : "-" },
      { "Metric": "Advanced Orders Count", "Value": clientsData ? clientsData.advanced_orders_count : "-" },
      { "Metric": "Completed Orders Count", "Value": clientsData ? clientsData.completed_orders_count : "-" },
      { "Metric": "Cancelled Orders Count", "Value": clientsData ? clientsData.cancelled_orders_count : "-" },
      { "Metric": "Customers Count", "Value": clientsData ? clientsData.customers_count : "-" },
      { "Metric": "Total Amount", "Value": clientsData ? clientsData.total_amount : "-" },
      { "Metric": "Total Paid Amount", "Value": clientsData ? clientsData.total_paid_amount : "-" },
    ];

    const summaryWs = XLSX.utils.json_to_sheet(summaryData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, summaryWs, "Summary");
    XLSX.writeFile(wb, "appointment_summary.xlsx");
  };

  return (
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Appointment Summary</h2>
          <p className="mb-4 text-center">Comprehensive list of all active appointment summary.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    {/* <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        /> */}
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Date Filter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-4">
                <Form.Label>Filter Type</Form.Label>
                <Form.Select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                  <option value={null}>Select Filter</option>
                  <option value="type1">Filter Type 1</option>
                  <option value="type2">Filter Type 2</option>
                </Form.Select>
              </Form.Group>

              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClients}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          <div className="live-preview">
            <Table responsive bordered hover className="text-center">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Count</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Bookings Count</td>
                  <td>{clientsData ? clientsData.total_bookings_count : "-"}</td>
                </tr>
                <tr>
                  <td>Coupon Orders Count</td>
                  <td>{clientsData ? clientsData.coupon_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Membership Orders Count</td>
                  <td>{clientsData ? clientsData.membership_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Instant Orders Count</td>
                  <td>{clientsData ? clientsData.instant_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Advanced Orders Count</td>
                  <td>{clientsData ? clientsData.advanced_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Completed Orders Count</td>
                  <td>{clientsData ? clientsData.completed_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Cancelled Orders Count</td>
                  <td>{clientsData ? clientsData.cancelled_orders_count : "-"}</td>
                </tr>
                <tr>
                  <td>Customers Count</td>
                  <td>{clientsData ? clientsData.customers_count : "-"}</td>
                </tr>
                <tr>
                  <td>Total Amount</td>
                  <td>{clientsData ? clientsData.total_amount : "-"}</td>
                </tr>
                <tr>
                  <td>Total Paid Amount</td>
                  <td>{clientsData ? clientsData.total_paid_amount : "-"}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div className="d-flex justify-content-start mt-4">
            <Button onClick={downloadCombinedExcel} variant="dark">Download as Excel</Button>
          </div>
    </Container>
  );
};

export default AppointmentSummary;
